var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.seriesTitle))])]),_c('v-card-text',[_c('vue-apex-charts',{key:_vm.k,attrs:{"options":_vm.chartOptions,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }